import { z } from 'zod';

const name = z
  .string()
  .min(3, { message: 'Name must be at least 3 characters long.' })
  .max(10, { message: 'Name must be no more than 10 characters long.' })
  .regex(/^[a-zA-Z0-9]+$/, {
    message: 'Name must contains only letters and numbers.',
  })
  .trim();
const email = z.string().email({ message: 'Please enter a valid email.' }).trim();
const password = z
  .string()
  .min(8, { message: 'Be at least 8 characters long' })
  .regex(/[a-zA-Zа-яА-ЯёЁ]/, { message: 'Contain at least one letter.' })
  .regex(/[0-9]/, { message: 'Contain at least one number.' })
  .regex(/[^a-zA-Zа-яА-ЯёЁ0-9]/, {
    message: 'Contain at least one special character.',
  })
  .trim();
const isString = z.string().trim();
const terms = z.boolean().refine((val) => val, { message: 'Please accept the terms.' });

const title = z
  .string()
  .min(10, { message: 'Title must be at least 10 characters long.' })
  .max(50, { message: 'Title must be no more than 50 characters long.' })
  .trim();
const character = z
  .string()
  .min(3, { message: 'Character must be at least 3 characters long.' })
  .max(20, { message: 'Character must be no more than 20 characters long.' })
  .trim();
const message = z
  .string()
  .min(20, { message: 'Message must be at least 20 characters long.' })
  .max(1000, { message: 'Message must be no more than 1000 characters long.' })
  .trim();
const category = z
  .number()
  .min(0, { message: 'Invalid category value.' })
  .max(3, { message: 'Invalid category value.' });
const topicId = z.number({ message: 'Invalid topicId value.' });
const messageId = z.number({ message: 'Invalid topicId value.' });

export const SignUpFormSchema = z
  .object({
    name,
    email,
    password,
    confirmPassword: isString,
    terms,
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'The passwords did not match.',
    path: ['confirmPassword'],
  });

const discordTitle = z
  .string()
  .min(10, { message: 'Title must be at least 10 characters long.' })
  .max(256, { message: 'Title must be no more than 256 characters long.' })
  .trim();
const discordMessage = z
  .string()
  .min(10, { message: 'Message must be at least 10 characters long.' })
  .max(4096, { message: 'Message must be no more than 4096 characters long.' })
  .trim();

export const SignInFormSchema = z.object({
  email,
  password: isString,
});

export const ResetFormSchema = z.object({
  email,
});

export const TopicFormSchema = z.object({
  title,
  character,
  message,
  category,
});

export const MessageFormSchema = z.object({
  topicId,
  message,
});

export const MessageEditFormSchema = z.object({
  messageId,
  message,
});

export const ChangePassFormSchema = z
  .object({
    oldPassword: isString,
    newPassword: password,
    confirmPassword: isString,
  })
  .refine((data) => data.newPassword === data.confirmPassword, {
    message: 'The passwords did not match.',
    path: ['confirmPassword'],
  });

const newsTitle = z
  .string()
  .min(10, { message: 'This field must be at least 10 characters long.' })
  .max(50, { message: 'This field must be no more than 50 characters.' })
  .trim();

const newsShort = z
  .string()
  .min(10, { message: 'This field must be at least 10 characters long.' })
  .max(200, { message: 'This field must be no more than 200 characters.' })
  .trim();

const newsFull = z
  .string()
  .min(10, { message: 'This field must be at least 10 characters long.' })
  .max(5000, { message: 'This field must be no more than 5000 characters.' })
  .trim();

export const DiscordFormSchema = z.object({
  channelId: isString,
  title: discordTitle,
  message: discordMessage,
});

export const NewsFormSchema = z.object({
  titleRu: newsTitle,
  titleEn: newsTitle,
  shortRu: newsShort,
  shortEn: newsShort,
  fullRu: newsFull,
  fullEn: newsFull,
  category,
});

export const ShopGoodsSchema = z.object({
  itemId: z.number().positive(),
  price: z.number().min(1).positive({ message: 'Price must be a positive integer.' }),
  categoryId: z.string(),
  descriptionRu: isString,
  descriptionEn: isString,
  quantity: z.number().min(1).positive({ message: 'Quantity must be a positive integer.' }),
});

export const ShopGoodsSchemaCreate = z.object({
  items: z.array(ShopGoodsSchema),
});

export const ShopItemSchema = z.object({
  itemId: z.number().positive(),
  price: z.number().min(1).positive({ message: 'Price must be a positive integer.' }),
  categoryId: z.string(),
  descriptionRu: isString,
  descriptionEn: isString,
  quantity: z.number().min(1).positive({ message: 'Quantity must be a positive integer.' }),
});
